import React from 'react'
import VideoConversation from './VideoConversation'
import AudioConversation from './AudioConversation'

/**
 * MediaWrap component - container for video and audio conversation components
 * Based on the op_next design from app/views/home/coach_chat/content/_video_wrap.html.erb
 *
 * @param {Object} props
 * @param {string} props.chatMode - Current chat mode (text, audio, video)
 * @param {string} props.chatStatus - Current chat status
 * @param {Object} props.chatManager - Chat manager instance
 */
const MediaWrap = ({
  chatMode,
  _chatStatus,
  chatManager,
  connectionState,
  hasLocalVideo,
  hasLocalAudio,
  hasRemoteVideo,
  _hasRemoteAudio,
  selectedCoach,
  bgEffectsEnabled = false,
}) => {
  // Don't show if chat mode is text
  if (chatMode === 'text') {
    return null
  }

  return (
    <div id="video_wrap" className="flex min-h-0 flex-1 flex-col">
      {/* Video conversation component */}
      <VideoConversation
        chatMode={chatMode}
        hasLocalVideo={hasLocalVideo}
        hasRemoteVideo={hasRemoteVideo}
        chatManager={chatManager}
        connectionState={connectionState}
        selectedCoach={selectedCoach}
        bgEffectsEnabled={bgEffectsEnabled}
      />

      {/* Audio conversation component */}
      <AudioConversation
        chatMode={chatMode}
        hasLocalAudio={hasLocalAudio}
        chatManager={chatManager}
        connectionState={connectionState}
        selectedCoach={selectedCoach}
      />
    </div>
  )
}

export default MediaWrap
